$(document).ready(function() {
    // Set alt tags for images
    $("img[data-src]").each(function() {
        const dataSrc = $(this).attr("data-src");
        let altText = "";
        // Determine alt text based on data source
        if (dataSrc.includes("mega-menu-114453-graphic-06")) {
            altText = "Apparel";
        } else if (dataSrc.includes("mega-menu-114453-drinkware-menu-images-1")) {
            altText = "Drinkware";
        } else if (dataSrc.includes("mega-menu-114453-kitchen-menu-images-1")) {
            altText = "Kitchen";
        } else if (dataSrc.includes("mega-menu-114453-grilling-menu-images-1")) {
            altText = "Grilling";
        }
        // Set alt attribute
        $(this).attr("alt", altText);
    });

setTimeout(function() {
    $("div.mm-image a[href='https://grillrescue.com/collections/grilling']").attr("aria-label", "Person doing grill");
    $("div.mm-image a[href='/collections/kitchen']").attr("aria-label", "Kitchen");
    $("div.mm-image a[href='/collections/drinkware']").attr("aria-label", "Drinkware");
    $("div.mm-image a[href='/collections/apparel']").attr("aria-label", "Apparel");
    $("img[src='https://ucarecdn.com/9478d6c2-3493-427f-9bed-1970e83e9370/-/format/auto/-/preview/3000x3000/-/quality/lighter/Drinkware-2%20_1_.png']").attr("alt", "Drinkware");
$("img[src='https://ucarecdn.com/0160943c-f57c-4600-b4c9-a00a59966af6/-/format/auto/-/preview/3000x3000/-/quality/lighter/beerbuddycollection-2.png']").attr("alt", "Beer Buddy Collection");
$("img[src='https://ucarecdn.com/4b20b0d5-b5dc-4cdf-99b4-af3e14c31bc7/-/format/auto/-/preview/3000x3000/-/quality/lighter/tumblerbuddycollection-2.png']").attr("alt", "Tumbler Buddy Collection");
$("img[src='https://ucarecdn.com/1ed0d04e-569a-48c9-ac5b-d90e33c2069f/-/format/auto/-/preview/3000x3000/-/quality/lighter/All_products-removebg-preview%20_1_.png']").attr("alt", "All Products");
$("img[src='https://app.adabundle.com/images/AdaBundle2.png']").attr("alt", "AdaBundle Logo");
$("img[src='https://ucarecdn.com/62dda3a6-1831-4b4d-9656-34c72a2d78fe/-/format/auto/-/preview/3000x3000/-/quality/lighter/Apron_Design1_5260a29f-09e6-45d7-a5d2-1e1536450476.png']").attr("alt", "Apron Design 1");
$("img[src='https://ucarecdn.com/85cc46d4-8aca-46ad-860f-6dcecde42d32/-/format/auto/-/preview/3000x3000/-/quality/lighter/America%20Edition%20Transparent%20_1_.png']").attr("alt", "America Edition Transparent");
$("img[src='https://ucarecdn.com/b2e8db5e-e720-44c2-ad43-5959613b3584/-/format/auto/-/preview/3000x3000/-/quality/lighter/All_products-removebg-preview%20_1_.png']").attr("alt", "All Products");
$("div[data-id='1692206609936'] p a[href='https://grillrescue.com/collections/kitchen']").attr("aria-label","kitchen collection");
  // Set alt tag for Grill Brushes image
$("img[src='https://ucarecdn.com/bc44789f-99eb-40da-a48f-04315e09700e/-/format/auto/-/preview/3000x3000/-/quality/lighter/grilling-2.png']").attr("alt", "Grill Brushes");

// Set alt tag for Scraper image
$("img[src='https://ucarecdn.com/73e97bfe-f942-46bd-8928-5fa486f8d069/-/format/auto/-/preview/3000x3000/-/quality/lighter/Scraper%20Head.png']").attr("alt", "Scraper");


}, 1000);

$("img#adCustomImage").attr("alt","custom image");
  $("img#obBadgeImage").attr("alt","Badge Image");
  $("div.mm-atc-product img.mm-atc-product-image").attr("alt","Product image");
$("div.owl-stage-outer a[href='/collections/grill-brushes']").attr("aria-label", "Grill Brushes");
$("div.owl-stage-outer a[href='/collections/accessories']").attr("aria-label", "Accessories");
$("div.owl-stage-outer a[href='/collections/caveman-collection']").attr("aria-label", "Caveman Collection");
$("div.owl-stage-outer a[href='/collections/aprons']").attr("aria-label", "Aprons");
$("img[src='https://ucarecdn.com/4ce1ee37-e869-4f29-985b-3d4204f07612/-/format/auto/-/preview/3000x3000/-/quality/lighter/brush%20_1_.png']").attr("alt", "Patented image");
 $("img[src='https://ucarecdn.com/421354f3-7216-461e-8fe8-481602383bf6/-/format/auto/-/preview/3000x3000/-/quality/lighter/MG_4242-2_600x600.png']").attr("alt", "Grill Rescue");
$("img[src='https://ucarecdn.com/e919f555-482b-43de-b360-facfcd14af66/-/format/auto/-/preview/3000x3000/-/quality/lighter/1_2b87c364-3b32-4584-8db2-18852d7ba97f.png']").attr("alt", "Caveman");
$("img[src='https://ucarecdn.com/bc17d178-06dd-4a25-bcb8-25bc34ea6ed4/-/format/auto/-/preview/3000x3000/-/quality/lighter/']").attr("alt", "30 days money back badge");
$("img[src='https://ucarecdn.com/f53b8802-1074-4a85-902a-edc625b354c9/-/format/auto/-/preview/3000x3000/-/quality/lighter/eco%20_1_.png']").attr("alt", "Eco-friendly");
$("img[src='https://ucarecdn.com/a7b1f5a0-b767-49fe-a19d-435d24c3e1a1/-/format/auto/-/preview/3000x3000/-/quality/lighter/Asset%201%20_1_.png']").attr("alt", "Antimicrobial");
$("img[src='https://ucarecdn.com/99dd6c9c-1359-42ee-af6d-ef9dabf8543b/-/format/auto/-/preview/3000x3000/-/quality/lighter/sud%20_1_.png']").attr("alt", "Sud Retention Technology");
$("img[src='https://ucarecdn.com/13a79190-53c2-4af1-92cf-5510b931811d/-/format/auto/-/preview/3000x3000/-/quality/lighter/heat.png']").attr("alt", "Heat Resistant");
$("img[src='https://ucarecdn.com/eff7e895-87d8-45a0-991e-1e727f05b6b8/-/format/auto/-/preview/3000x3000/-/quality/lighter/1.png']").attr("alt", "Long Lasting Design");
$("img[src='https://ucarecdn.com/76981170-02a1-4cb7-a2ec-741af20b9bc5/-/format/auto/-/preview/3000x3000/-/quality/lighter/image%20_26_.png']").attr("alt", "Safeguard Your Family");
$("img[src='https://ucarecdn.com/f07f9fd9-fa8e-434c-8881-f19e20f5021b/-/format/auto/-/preview/3000x3000/-/quality/lighter/3%20_2_.png']").attr("alt", "Good Cause");
$("img[src='https://ucarecdn.com/54899785-e973-488b-9224-3d77e9933e45/-/format/auto/-/preview/3000x3000/-/quality/lighter/164d2da5-325c-4bf7-9b2e-58dc98ce8546.png']").attr("alt", "caveman grill");
$("img[src='https://ucarecdn.com/2b984978-7691-440c-b240-860c7a89d5db/-/format/auto/-/preview/3000x3000/-/quality/lighter/']").attr("alt", "mockups for support in laptop and mobile");
$("img[src='https://ucarecdn.com/3b3c82d0-6ca3-4735-b3cb-9ab4f6dae4fb/-/format/auto/-/preview/3000x3000/-/quality/lighter/']").attr("alt", "mockups for support in laptop and mobile");
$("img[src='https://ucarecdn.com/3d20d0c3-7903-4fc1-91d0-9cd3b4df8018/-/format/auto/-/preview/3000x3000/-/quality/lighter/Drinkware-2%20_1_.png']").attr("alt", "Tumbler buddy collection");
$('div[data-id="1690994337026"] a[href="https://grillrescue.com/products/grill-brush-w-scraper"]').attr("aria-label","grill brush with scrapper");
$("img[src='https://ucarecdn.com/c828587f-1f8f-46f3-9be6-936336f5b34a/-/format/auto/-/preview/3000x3000/-/quality/lighter/All_products-removebg-preview%20_1_.png']").attr("alt", "All products collection");
$('a[href="https://www.indiegogo.com/projects/forever-sponge-the-sponge-that-doesn-t-die/x/31415849#/"]').attr("aria-label","forever spunge");
  $("img[src='//grillrescue.com/cdn/shop/files/CavemanMini_4_2048x2048.png?v=1701710537']").attr("alt", "Caveman Mini grill image");

$("img[src='https://ucarecdn.com/df8654f5-f328-44c3-9358-b580e0c85fcb/-/format/auto/-/preview/3000x3000/-/quality/lighter/ffphone-3.png']").attr("alt", "Landline telephone image");
$(".hero-link[href='/collections/grill-brushes']").attr("aria-label", "Grill brushes");
$(".hero-link[href='/collections/caveman-collection']").attr("aria-label", "Caveman collection");
$(".hero-link[href='/collections/drinkware']").attr("aria-label", "Drinkware");
$(".hero-link[href='/collections/kitchen']").attr("aria-label", "Kitchen");
$(".hero-link[href='/products/ultimate-grill-rescue-bundle']").attr("aria-label", "Ultimate grill rescue bundle");
$(".hero-link[href='/collections/beer-buddy']").attr("aria-label", "Beer buddy");
$("img[src='https://ucarecdn.com/07518f5e-e9ac-4e57-8421-366b9e509a1a/-/format/auto/-/preview/3000x3000/-/quality/lighter/All_products-removebg-preview%20_1_.png']").attr("alt", "All products collection");
$('input[name^="quantity"]').attr("aria-label","Quantity");
    // Set alt tag for Beer Buddy Lying on Table image
    $("img[src='https://ucarecdn.com/34c62973-7355-4352-9a36-e001f37a6b88/-/format/auto/-/preview/3000x3000/-/quality/lighter/download.png']").attr("alt", "Beer Buddy Lying on Table");

    // Set alt tag for Tumbler Buddy Lying on Table image
    $("img[src='https://ucarecdn.com/198c87cd-d98a-4eb0-a9c2-57de92dcba13/-/format/auto/-/preview/3000x3000/-/quality/lighter/TB_Cold%20copy-2.jpg']").attr("alt", "Tumbler Buddy Lying on Table");

    // Set alt tag for Person Cooking Food Through Caveman image
    $("img[src='https://ucarecdn.com/fadc8012-8734-49df-b027-eb8d92a88db0/-/format/auto/-/preview/3000x3000/-/quality/lighter/2%20_3_.jpg']").attr("alt", "Person Cooking Food Through Caveman");
$("div.owl-stage-outer a[href='/pages/shop']").attr("aria-label", "Shop");
$("a[href='#looxReviews']").attr("aria-label","loox reviews");
  $("#advanceStream").append("<span style='display:none'>. </span>");
  $("a[href='https://www.shopify.com?utm_campaign=poweredby&amp;utm_medium=shopify&amp;utm_source=onlinestore']").attr("aria-label", "Shopify Online Store");
$("input[name='quantity']").attr("aria-label", "Quantity");

  $("input[name='contact[name]']").attr("aria-label", "Name");
$("input[name='contact[phone]']").attr("aria-label", "Phone");
$("input[name='contact[email]']").attr("aria-label", "Email");
$("textarea[name='contact[message]']").attr("aria-label", "Message");
$("img[src='https://ucarecdn.com/671ed76e-7009-4f67-9e2b-7c149a8d37bb/-/format/auto/-/preview/3000x3000/-/quality/lighter/']").attr("alt", "Laptop image");

let Intervaltime_google;
let counter_google = 0; // counter to track the number of times the function is called


try {
    Intervaltime_google = setInterval(GenerateAriaLabelForGoogle, 500);
}
catch (err) {
  
}


function GenerateAriaLabelForGoogle() {
    // Increment the counter each time the function is called
    counter_google++;


    // Check if the target element exists
    if ( $('#goog-gt-votingInputSrcLang').length) {
$("label.adb-switch").append('<span style="display:none">.</span>');

$('#goog-gt-votingInputSrcLang').attr('aria-label', 'Source Language');
  $('#goog-gt-votingInputTrgLang').attr('aria-label', 'Target Language');
  $('#goog-gt-votingInputSrcText').attr('aria-label', 'Source Text');
  $('#goog-gt-votingInputTrgText').attr('aria-label', 'Translated Text');
  $('#goog-gt-votingInputVote').attr('aria-label', 'Vote');
      
        clearInterval(Intervaltime_google);
       
    }
    
    // Clear the interval if the function has been called 10 times
    if (counter_google >= 10) {
        clearInterval(Intervaltime_google);
       
    }
}

  var text = "bundle";
    $("strong").filter(function() {
        return $(this).text().trim() === text;
    }).css("color", "#757575 !important");  
 
});


window.onload = function() {
  setTimeout(function() {
    $("div.mm-image a[href='https://grillrescue.com/collections/grilling']").attr("aria-label", "Person doing grill");
    $("div.mm-image a[href='/collections/kitchen']").attr("aria-label", "Kitchen");
    $("div.mm-image a[href='/collections/drinkware']").attr("aria-label", "Drinkware");
    $("div.mm-image a[href='/collections/apparel']").attr("aria-label", "Apparel");
 $("img[src^='//grillrescue.com/cdn/shop/files/Caveman_4]").attr("alt", "caveman grill zoom image");
      $("img[src='//grillrescue.com/cdn/shop/files/CavemanMini_4_2048x2048.png?v=1701710537']").attr("alt", "Caveman Mini grill image");
    $("img[src='https://ucarecdn.com/188d3f1b-8803-4ade-8177-efae032ce89b/-/format/auto/-/preview/3000x3000/-/quality/lighter/IMG_3465.jpg']").attr("alt", "Tough hanger");
$("img[src='https://ucarecdn.com/6b54133a-a32c-48f6-8040-d132c1dc0bd7/-/format/auto/-/preview/3000x3000/-/quality/lighter/IMG_3476.png']").attr("alt", "Sturdy hanger");
$("img[src='https://ucarecdn.com/227071db-af5b-4d07-ba54-d4a1004093ad/-/format/auto/-/preview/3000x3000/-/quality/lighter/IMG_3533-_1_.png']").attr("alt", "Slides on snug");
$("img[src='https://ucarecdn.com/00923aad-fc79-4c34-a314-4513dd60a081/-/format/auto/-/preview/3000x3000/-/quality/lighter/IMG_3478.jpg']").attr("alt", "Slides on snug");
$("img[src='https://ucarecdn.com/83ca6023-d1b1-45f3-b985-4df4f76e5989/-/format/auto/-/preview/3000x3000/-/quality/lighter/IMG_3467.jpg']").attr("alt", "Detachable");

    $("img[src^='https://cdn.shopify.com/s/files/1/0397/1946/9215/t/15/assets/mega-menu-114453-kitchen-menu-images']").attr("alt", "Kitchen");
$("img[src^='https://cdn.shopify.com/s/files/1/0397/1946/9215/t/15/assets/mega-menu-114453-drinkware-menu-images']").attr("alt", "Drinkware");
$("img[src^='https://cdn.shopify.com/s/files/1/0397/1946/9215/t/15/assets/mega-menu-114453-grilling-menu-images']").attr("alt", "Grilling");
   var text = "bundle";
    $("strong").filter(function() {
        return $(this).text().toLowerCase().trim() === text;
    }).css("color", "#757575 !important");
  },1000);
  $("div.custom-variant-swatches a > img").each((index, element) => { if(!$(element).attr("alt") || $(element).attr("alt") === "") { $(element).attr("alt", $(element).parent().attr("href").split("/").pop().replace(/-/g, " ")); } });
};

